import * as React from 'react';

import {FlashBanner} from 'shells/flash-banner/flash-banner';

import {ChartEmptyState} from './empty-state/chart-empty-state';
import {LoadingChart} from './loading-chart';

import styles from './error-chart.module.css';

type ErrorChartProps = {
    errorMessage: string;
    onRetry: (...args: any) => any;
    showLoading?: boolean;
    vertical: boolean;
};

export function ErrorChart(props: ErrorChartProps) {
    return (
        <div>
            <FlashBanner type='error' className={styles['flash-banner']}>
                <span>{props.errorMessage}</span>
                <button className={styles['error-retry-button']} onClick={props.onRetry}>
                    RETRY
                </button>
            </FlashBanner>
            {props.showLoading ? (
                <LoadingChart />
            ) : (
                <ChartEmptyState isError={true} isVertical={props.vertical} />
            )}
        </div>
    );
}
